import React from 'react';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { GuildsSelect, ProductsSelect, BusinessesSelect, HeaderSection } from 'components';
import Beneficiary from './components/Beneficiary';

const Constraints = ({
  selectedProducts,
  setSelectedProducts,
  selectedGuilds,
  setSelectedGuilds,
  selectedBusinesses,
  setSelectedBusinesses,
  setBeneficiary,
  beneficiary,
  stakeholderList,
}) => {
  const methods = useFormContext();

  return (
    <>
      <Grid container direction="row" alignItems="center" spacing={2} item xs={12} md={6} lg={4}>
        <GuildsSelect
          selected={selectedGuilds}
          setSelected={setSelectedGuilds}
          methods={methods}
          name="gildUsages"
          label="محدودیت روی حساب تفصیلی کسب‌وکار"
        />
        <ProductsSelect
          selected={selectedProducts}
          setSelected={setSelectedProducts}
          methods={methods}
          name="serviceUsage"
          label="محدودیت روی شناسه محصول"
        />
        <BusinessesSelect
          selected={selectedBusinesses}
          setSelected={setSelectedBusinesses}
          methods={methods}
          name="permittedBusinessId"
          label="محدودیت روی کسب‌وکار"
        />
      </Grid>

      <Grid item xs={12} lg={8}>
        <HeaderSection title="تعریف ذینفعان" />
        <Beneficiary
          setBeneficiary={setBeneficiary}
          beneficiary={beneficiary}
          stakeholderList={stakeholderList}
        />
      </Grid>
    </>
  );
};
export default Constraints;
